"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireWildcard(require("react"));
var _Title = _interopRequireDefault(require("../../Title"));
var _Article = _interopRequireDefault(require("../../Article"));
var _utils = require("../../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var Renderer = function Renderer(restProps) {
  var _a = (restProps || {}).articleList,
    articleList = _a === void 0 ? [] : _a;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("section", {
    style: {
      overflow: 'hidden'
    }
  }, articleList.map(function (item, index) {
    var _a = item || {},
      content = _a.content,
      title = _a.title;
    return /*#__PURE__*/_react["default"].createElement(_Article["default"], {
      key: index,
      titleStyle: {
        fontSize: '18px',
        color: '#000000',
        lineHeight: '27px'
      },
      contentStyle: {
        fontSize: '16px',
        color: 'rgba(0,0,0,0.60)',
        lineHeight: '24px'
      },
      pc: {
        justifyContent: 'content',
        alignItems: 'center',
        background: 'none',
        // last child mb 0 //todo
        marginBottom: index + 1 === articleList.length ? '0' : '36px'
      },
      mo: {
        paddingTop: '20px'
      },
      article: content,
      title: title
    });
  })));
};
var MultipleTemp = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var icon = props.icon,
    banner = props.banner,
    sharp = props.sharp,
    radius = props.radius,
    source = props.source,
    flexTitle = props.flexTitle,
    style = props.style,
    article = props.article,
    configuration = props.configuration,
    className = props.className,
    restProps = __rest(props, ["icon", "banner", "sharp", "radius", "source", "flexTitle", "style", "article", "configuration", "className"]);
  var _a = configuration || {},
    imageSrc = _a.imageSrc,
    articleList = _a.articleList,
    _b = _a.imageLocation,
    imageLocation = _b === void 0 ? false : _b;
  var _c = (0, _utils.fomateFileData)(imageSrc),
    url = _c.url,
    _d = _c.alt,
    alt = _d === void 0 ? '' : _d;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-multiple-container',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-multiple-container-children'
  }, /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    title: flexTitle
  }), /*#__PURE__*/_react["default"].createElement("section", __assign({
    ref: ref
  }, restProps, {
    style: {
      height: 'fit-content',
      padding: '0 24px'
    }
  }), !imageLocation ? (/*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-container-mian-left'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-container-left'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-container-img'
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: url,
    style: {
      width: '100%'
    },
    alt: alt
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-container-right'
  }, /*#__PURE__*/_react["default"].createElement(Renderer, __assign({
    articleList: articleList
  }, restProps))))) : (/*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-container-mian-right'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-container-left'
  }, /*#__PURE__*/_react["default"].createElement(Renderer, __assign({
    articleList: articleList
  }, restProps))), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-container-right'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-container-img'
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: url,
    style: {
      width: '100%'
    },
    alt: alt
  }))))))));
});
MultipleTemp.displayName = 'TCITabs';
var _default = exports["default"] = MultipleTemp;